import { FetchCustomFieldValuesSortTypes } from './customFieldValuesTypes';

export const INITIAL_CUSTOM_FIELD_FILTERS = {};
export const INITIAL_CUSTOM_FIELD_LIMIT = 1000;
export const INITIAL_CUSTOM_FIELD_PAGE = 1;
export const INITIAL_CUSTOM_FIELD_SORT = [
  FetchCustomFieldValuesSortTypes.CREATED_AT_ASC
];
